/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useMemo } from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import { formatCurrentTime } from "../../../../../../shared/utils/time";
import { usePlayerAdvertisementTracker } from "../../../../../BasePlayer";

import "./PositionIndicator.scss";

export const PositionIndicator = () => {
  const {
    tracker: { duration, position, totalAds, title },
  } = usePlayerAdvertisementTracker();

  const { t } = usePlayerTranslation();

  const description: string = useMemo(() => {
    const time = formatCurrentTime(duration);

    if (totalAds <= 1) {
      return t("PLAYER_SINGLE_AD_INDICATOR", { time, title });
    }

    return t("PLAYER_MULTIPLE_ADS_INDICATOR", {
      position,
      totalAds,
      time,
      title,
    });
  }, [duration, position, title, totalAds]);

  return <div className="PositionIndicator">{description}</div>;
};
